import EventBus from '@/helpers/event-bus';
import CompanyService from '@/services/Companies/CompanyService';
import UserService from '@/services/User/UserService';

const state = {
    data: [],
    loggedUserCompanies: []
};

const actions = {
    async getCompanies({ commit }) {
        try {
            const { data } = await CompanyService.getCompanies();
            commit('setData', data);
        } catch (error) {
            console.error(error);
        }

    },
    async getUserAttachedCompany({ commit, rootGetters }, userId) {
        const { data } = await CompanyService.getCompanies();
        const response = await UserService.getUserAttachedCompany(userId);

        if (response.data && response.data.companies.length) {
            let userCompanies = data;

            if (rootGetters['user/isAdmin'] === false) {
                userCompanies = data.filter(company => response.data.companies.indexOf(company.id) > -1);
            }
            commit('setLoggedUserCompanies', userCompanies);
            return userCompanies;
        }

    },
    async updateCompany(_, companyData) {
        let isError = false;
        try {
            const { data } = await CompanyService.updateCompany(companyData);
            if (data && data.status === 1) {
                EventBus.$emit('snotifySuccess', 'Company data updated');
            }
        } catch (error) {
            if (error.response.data.errors.length) {
                EventBus.$emit('snotifyError', error.response.data.errors[0].msg);
            } else {
                EventBus.$emit('snotifyError', 'Company data update error.');
            }
            isError = true;
        }
        return isError;
    }
};

const mutations = {
    setData(state, data) {
        state.data = JSON.parse(JSON.stringify(data));
    },
    setLoggedUserCompanies(state, companies) {
        state.loggedUserCompanies = JSON.parse(JSON.stringify(companies));
    }
};

const getters = {
    data(state) {
        return state.data;
    }
};

export default {
    state,
    mutations,
    actions,
    getters,
    namespaced: true
};
